import React, { FC, useState } from 'react';
import { BUTTON_TYPE, ButtonComponent } from '../ButtonComponent';
import clsx from 'clsx';
import { IModalWindow, ModalWindow } from '../modal/ModalWindow';
import { IRelatedMerchants } from '../../store/payments/payments-interfaces-helper';
import { RELATED_ENTITY_TYPE, RelatedEntityNameLink } from '../merchants/RelatedEntityNameLink';

interface Props {
  name: string;
  secondaryName: string;
  additionalClass?: string;
  secondaryAdditionalClass?: string;
  relatedMerchantsList?: IRelatedMerchants[];
  relatedMerchantsCount: number;
}
export const RelatedMerchants: FC<Props> = (props) => {
  const { name, secondaryName, additionalClass, secondaryAdditionalClass, relatedMerchantsList, relatedMerchantsCount } = props;

  const [modalState, setModalState] = useState<IModalWindow>({
    isOpen: false
  });

  const onCloseModal = (): void => setModalState(prevState => ({ ...prevState, isOpen: false }));

  const openModal = (): void => {
    setModalState({
      isOpen: true,
      isRightSideModal: true,
      size: 'xs',
      modalTitle: 'Related Merchants',
      contentClassName: 'd-block pb-1',
      cypressAttribute: 'related-merchants-modal',
      content: (
        <div className="px-8" data-cy="related-merchants-list">
          {
            relatedMerchantsList?.map(({ id }, index) => (
              <div key={id} className="mt-2 d-flex align-items-center" data-cy="related-merchants-item">
                <span className="text-danger fw-bolder me-1">{index + 1}. </span>
                <RelatedEntityNameLink id={id} type={RELATED_ENTITY_TYPE.MERCHANT} />
              </div>
            ))
          }
        </div>
      )
    });
  };

  return (
    <>
      {
        relatedMerchantsCount
          ? (
            <ButtonComponent
              additionalClass={clsx('no-letter-spacing',additionalClass)}
              buttonName={name}
              buttonType={BUTTON_TYPE.FAKE_LINK}
              onButtonClick={openModal}
              withoutUnderline={true}
              cypressAttribute="related-merchants-button"

            />
          ) : (
            <span className={secondaryAdditionalClass}>{secondaryName}</span>
          )
      }

      <ModalWindow
        {...modalState}
        onClose={onCloseModal}
      />
    </>
  );
};